module.exports = __webpack_public_path__ + "img/top-bg-cjhdfc.4248fa64.png";